import { config, useAppStore } from "@/controller";
import DictationVocabularyFields from "@/components/DictationVocabularyFields";
import {
  composeDictationVocabularyRules,
  type DictationVocabularySettings,
} from "@/dictation-interactions";
import { configureGlobalDictationAsync } from "@/models/useGlobalDictation";

// Native adapter around the shared vocabulary fields. Desktop and browser
// dictation read the persisted rules directly; native keyboard surfaces also
// need their live configuration refreshed after each edit.
const DictationVocabularyEditor = () => {
  const userToken = useAppStore((state) => state.userToken);
  const configureNative = (next: DictationVocabularySettings) => {
    void configureGlobalDictationAsync({
      authToken: userToken || "",
      serverUrl: config.apiUrl,
      vocabularyRules: composeDictationVocabularyRules(next),
    }).catch(() => undefined);
  };

  return <DictationVocabularyFields afterSave={configureNative} />;
};

export default DictationVocabularyEditor;
